var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMelioSecondaryMono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 45,
    viewBox: "0 0 251 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.038 0C240.698 0 250.358 9.24051 250.358 22.0205C250.358 34.7404 240.698 44.04 228.038 44.04C215.258 44.0398 205.719 34.8003 205.719 22.0205C205.719 9.24065 215.378 0.000200473 228.038 0ZM24.7803 31.7402L37.5605 0.720703H49.1396V43.3203H41.3398V8.40039L27.0605 43.5H21.6006L7.44043 8.7002V43.3203H0V0.720703H12.0605L24.7803 31.7402ZM105.279 7.68066H78.8193V17.4004H94.5986V24.4199H78.8193V36.1807H107.679V43.3203H70.7793V0.720703H105.279V7.68066ZM133.836 36.0605H160.176V43.3203H125.796V0.720703H133.836V36.0605ZM186.278 43.3203H178.178V0.720703H186.278V43.3203ZM228.038 7.32031C219.578 7.32053 213.998 13.9206 213.998 22.0205C213.998 30.2403 219.518 36.7205 228.038 36.7207C236.558 36.7207 242.139 30.1804 242.139 22.0205C242.139 13.9205 236.558 7.32031 228.038 7.32031Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMelioSecondaryMono);
export default __webpack_public_path__ + "static/media/melio-secondary-mono.f7ed8b9d42af3e34cd4886ee2e812a17.svg";
export { ForwardRef as ReactComponent };